<div [ngClass]="{
  'box-border rounded-3xl shadow-black-500/50 p-4': true,
  'blank': variant === 'blank',
  'plain': variant === 'plain'
  }">
  <ng-content></ng-content>
</div>
